// Documento: Como comenzar a usar nuestra aplicación
// Categoría: Comienzo
// Última actualización: 2024-12-28

const document = {
  "id": "como-comenzar-aplicacion",
  "title": "Como comenzar a usar nuestra aplicación",
  "category": "Comienzo",
  "description": "Guía simple para comenzar a utilizar Runamatic con una cuenta demo gratuita o suscribiéndose a nuestros planes.",
  "steps": [
    {
      "title": "Cuenta Demo Gratuita",
      "content": "Pueden comenzar a usar nuestra plataforma totalmente gratis con una cuenta demo, se pueden crear una cuenta apretando el botón \"Acceder\" desde nuestra web."
    },
    {
      "title": "Cuenta Personal",
      "content": "Para poder acceder a su cuenta personal deben suscribirse a uno de nuestros planes."
    },
    {
      "title": "Planes Pro y Pro + AI",
      "content": "Planes Pro y Pro + AI pueden suscribirse desde nuestra web o por WhatsApp."
    },
    {
      "title": "Plan Runamatic",
      "content": "Plan Runamatic solo por WhatsApp."
    }
  ],
  "tags": [
    "inicio",
    "planes",
    "demo",
    "suscripción"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
